import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import useLinkProps from '../../../../../hooks/use-link-props';
import BackgroundLink from '../../../../ui/links/background';
import ImageLabel from '../../../../ui/v2/products/image-label';
import { Carousel, CarouselBullets, CarouselContent, CarouselItem } from '../../../../ui/carousel-v2';

const LastVehicles: FunctionComponent<{
  products: Array<TVehicleCard>;
  vehicle?: TCarInfo;
}> = ({ products, vehicle }) => {
  const { t } = useTranslation();
  const getLink = useLinkProps();

  const referenceVisible = products.filter(el => el.car?.engine || el.engine_code);

  return (
    <section className={cx('bg-neutral-10', 'pt-12', 'pb-[42px]')}>
      <span
        className={cx(
          'container mx-auto',
          'block',
          'max-lg:px-8',
          'font-bold',
          'text-[22px]',
          'lg:text-[32px]',
          'text-center',
          'mb-6'
        )}
      >
        {t('vehicle:last-vehicles', {
          vehicle: `${vehicle?.brand?.name || ''} ${vehicle?.model?.name || ''
            }`,
        })}
      </span>

      <div className="container m-auto">
        <Carousel
          opts={{
            align: 'center',
          }}
          viewportBasedSlidesToScroll={{
            desktop: 4,
            mobile: 1,
          }}
        >
          <CarouselContent className="pb-2 lg:-ml-6">
            {products.map((product) => {
              return <CarouselItem
                key={product.id.toString()}
                className="pl-0 basis-4/5 lg:basis-1/4 lg:pl-6 lg:grid lg:grid-cols-1 lg:gap-6 max-lg:h-fit"
              >
                <BackgroundLink
                  variant="DEFAULT"
                  {...getLink('vehicle', {
                    vehicle: product.slug,
                  })}
                >
                  <ImageLabel
                    product={product}
                    isVehicle
                    altImage={'common:images_alt.last_vehicles_alt'}
                    engineAvailable={referenceVisible.length > 0}
                  />
                </BackgroundLink></CarouselItem>
            })}
          </CarouselContent>
          <CarouselBullets className="!mt-6 max-lg:hidden" />
        </Carousel>
      </div>
    </section>
  );
};

export default LastVehicles;
